import React, { memo } from 'react';

import { PageError } from '@/components/Error';
import { FormProps } from '@/components/Form';
import Loader from '@/components/Loader';
import useFile from '@/modules/tasks/views/TasksDashboard/hooks/useFile';

import Editor from './components/Editor';
import { ProjectEditorFormValues } from './components/Editor/config';

function ProjectEditorContainer({
  setFormikSubmit,
  onSubmit,
  file,
  fetching,
  error,
  initialValues,
}: {
  setFormikSubmit: FormProps<ProjectEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<ProjectEditorFormValues>['onSubmit'];
  file?: ReturnType<typeof useFile>['file'];
  fetching: boolean;
  error?: any;
  initialValues?: Partial<ProjectEditorFormValues>;
}) {
  if (fetching) {
    return <Loader />;
  }

  if (error) {
    return <PageError error={error} />;
  }

  return (
    <Editor
      file={file}
      initialValues={initialValues}
      setFormikSubmit={setFormikSubmit}
      onSubmit={onSubmit}
    />
  );
}

export default memo(ProjectEditorContainer);
